// Copyright (c) Bentley Systems
import { SVGProps, useEffect, useState } from "react";
import { animated, useSprings } from "@react-spring/web";
import { AnimatedIconProps } from "./AnimatedIconProps";

const BottomRectangle = (props: React.JSX.IntrinsicAttributes & SVGProps<SVGGElement>) => {
  return (
    <g {...props}>
      <rect
        width="42"
        height="42"
        fill="#67b01a"
        fillOpacity="60%"
        stroke="#fff"
        strokeOpacity="0.6"
        strokeWidth="0.5"
        rx="3"
        ry="3"
        transform="translate(5 5)"
       />
      <path
        transform="translate(5)"
        fill="#fff"
        d="M27.285 14.906h3.74c.381 0 .578-.472.303-.735l-4.424-4.423a.43.43 0 00-.735.302v3.74c0 .617.5 1.13 1.13 1.13l-.014-.014z"
       />
      <path
        transform="translate(5)"
        fill="#fff"
        d="M30.855 16.875h-5.552a1.1 1.1 0 01-1.102-1.103v-5.565C24.2 9.538 23.663 9 22.993 9H9.947c-.84 0-1.51.67-1.51 1.51v28.48c0 .84.67 1.51 1.51 1.51h20.606c.84 0 1.51-.67 1.51-1.51V18.083c0-.669-.539-1.207-1.208-1.207zm-10.763-1.444a.8.8 0 01-.511-.197l-1.063.552v.026a1.2 1.2 0 01-.355.853c.263.578.512 1.168.775 1.746a1.322 1.322 0 011.286 1.325c0 .722-.604 1.339-1.339 1.339a1.344 1.344 0 01-1.339-1.339c0-.367.158-.708.394-.945-.21-.59-.407-1.194-.617-1.785h-.013c-.289 0-.551-.118-.761-.288-.643.301-1.286.603-1.916.879v.013a2.112 2.112 0 01-2.114 2.113 2.112 2.112 0 01-2.113-2.113c0-1.168.945-2.113 2.113-2.113.643 0 1.195.302 1.588.748.67-.197 1.352-.42 2.048-.63a1.21 1.21 0 01.433-.735l-.315-.906c-.092.027-.197.066-.289.066a1.344 1.344 0 01-1.338-1.339c0-.735.603-1.338 1.338-1.338.735 0 1.34.603 1.34 1.338 0 .407-.185.748-.473.998.13.315.275.617.406.932h.053c.328 0 .63.13.84.354.394-.131.748-.262 1.116-.394a.82.82 0 01.813-.774c.433 0 .814.367.814.814a.818.818 0 01-.814.813l.013-.013z"
       />
      <path
        transform="translate(5)"
        fill="#1E1E1E"
        d="M23.433 29.201c-.183-.257-.452-.379-.794-.379-.72 0-1.087.514-1.087 1.553 0 1.04.367 1.54 1.075 1.54.367 0 .635-.122.806-.378.171-.245.269-.636.269-1.162 0-.526-.098-.917-.269-1.174zm0 0c-.183-.257-.452-.379-.794-.379-.72 0-1.087.514-1.087 1.553 0 1.04.367 1.54 1.075 1.54.367 0 .635-.122.806-.378.171-.245.269-.636.269-1.162 0-.526-.098-.917-.269-1.174zm8.734-4.451H14.333A2.334 2.334 0 0012 27.086v6.578A2.326 2.326 0 0014.333 36h17.834a2.334 2.334 0 002.333-2.336v-6.578a2.342 2.342 0 00-2.333-2.336zM19.39 31.88v1.16h-3.469v-5.306h1.43v4.145h2.04zm.66-1.505c0-.893.22-1.565.66-2.03.439-.465 1.086-.697 1.93-.697.842 0 1.477.232 1.917.697.428.453.647 1.137.647 2.03 0 .893-.22 1.577-.66 2.042-.439.465-1.074.697-1.917.697s-1.466-.232-1.918-.71c-.44-.464-.66-1.136-.66-2.029zm10.529 2.421a6.45 6.45 0 01-2.052.318c-.819 0-1.441-.244-1.893-.71-.44-.476-.672-1.16-.672-2.029 0-.868.244-1.528.733-2.005.488-.477 1.172-.71 2.052-.71.342 0 .647.025.952.086.294.061.55.147.77.245l-.452 1.125a2.715 2.715 0 00-1.258-.282c-.415 0-.745.135-.965.404-.232.269-.342.66-.342 1.174 0 .513.098.868.305 1.125.208.269.501.391.892.391.208 0 .415 0 .586-.061v-.832h-.94v-1.1h2.284v2.861zm-7.146-1.26c.171-.244.269-.635.269-1.161s-.098-.917-.269-1.174c-.183-.257-.452-.379-.794-.379-.72 0-1.087.514-1.087 1.553 0 1.04.367 1.54 1.075 1.54.367 0 .635-.122.806-.378z"
       />
      <path
        transform="translate(5)"
        fill="#0E630A"
        d="M23.433 29.201c-.183-.257-.452-.379-.794-.379-.72 0-1.087.514-1.087 1.553 0 1.04.367 1.54 1.075 1.54.367 0 .635-.122.806-.378.171-.245.269-.636.269-1.162 0-.526-.098-.917-.269-1.174zm0 0c-.183-.257-.452-.379-.794-.379-.72 0-1.087.514-1.087 1.553 0 1.04.367 1.54 1.075 1.54.367 0 .635-.122.806-.378.171-.245.269-.636.269-1.162 0-.526-.098-.917-.269-1.174zm8.734-4.451H14.333A2.334 2.334 0 0012 27.086v6.578A2.326 2.326 0 0014.333 36h17.834a2.334 2.334 0 002.333-2.336v-6.578a2.342 2.342 0 00-2.333-2.336zM19.39 31.88v1.16h-3.469v-5.306h1.43v4.145h2.04zm.66-1.505c0-.893.22-1.565.66-2.03.439-.465 1.086-.697 1.93-.697.842 0 1.477.232 1.917.697.428.453.647 1.137.647 2.03 0 .893-.22 1.577-.66 2.042-.439.465-1.074.697-1.917.697s-1.466-.232-1.918-.71c-.44-.464-.66-1.136-.66-2.029zm10.529 2.421a6.45 6.45 0 01-2.052.318c-.819 0-1.441-.244-1.893-.71-.44-.476-.672-1.16-.672-2.029 0-.868.244-1.528.733-2.005.488-.477 1.172-.71 2.052-.71.342 0 .647.025.952.086.294.061.55.147.77.245l-.452 1.125a2.715 2.715 0 00-1.258-.282c-.415 0-.745.135-.965.404-.232.269-.342.66-.342 1.174 0 .513.098.868.305 1.125.208.269.501.391.892.391.208 0 .415 0 .586-.061v-.832h-.94v-1.1h2.284v2.861zm-7.146-1.26c.171-.244.269-.635.269-1.161s-.098-.917-.269-1.174c-.183-.257-.452-.379-.794-.379-.72 0-1.087.514-1.087 1.553 0 1.04.367 1.54 1.075 1.54.367 0 .635-.122.806-.378z"
       />
    </g>
  );
}

const TopRectangle = (props: React.JSX.IntrinsicAttributes & SVGProps<SVGGElement>) => {
  return (
    <g {...props}>
      <rect
        width="42"
        height="42"
        fill="#87cd1e"
        stroke="#83c444"
        strokeWidth="0.5"
        rx="3"
        ry="3"
        transform="translate(0)"
       />
    </g>
  );
}

const LogAnim = (props: AnimatedIconProps) => {
  const [toggle, setToggle] = useState(false);

  useEffect(() => {
    if (props.isFocused !== undefined) {setToggle(props.isFocused);}
  }, [props]);

  const rectangles = [
    <TopRectangle key="rectangle1" />,
    <BottomRectangle key="rectangle2" />,
  ];

  const springs = useSprings(
    rectangles.length, // the number of springs to create
    rectangles.map((el, index) => {
      return {
        transform: toggle
          ? `translate3d(0px, 0px, 0px)`
          : `translate3d(${index === 1 ? -5 : 5}px, 0px, 0px)`,
      };
    })
  );

  const animatedRectangles = springs.map((animatedStyle, index) => (
    // use `animated.g` instead of `g` as the `animatedStyle`
    // is a special react-spring flavour of the `style` property
    <animated.g
      key={index}
      style={animatedStyle} // apply the animated style
    >
      {rectangles[index]}
    </animated.g>
  ));

  return (
    <div
      onMouseOver={() => {
        if (props.isFocused === undefined) {setToggle(true);}
      }}
      onMouseOut={() => {
        if (props.isFocused === undefined) {setToggle(false);}
      }}
    >
      <svg
        style={{ height: "100%", width: "100%" }}
        xmlns="http://www.w3.org/2000/svg"
        width="47"
        height="47"
        viewBox="0 0 47 47"
      >
        {animatedRectangles}
      </svg>
    </div>
  );
};

export default LogAnim;
